/// <reference types="bootstrap"/>
import BootstrapTab from 'bootstrap/js/dist/tab';
class Tab {
    constructor(config) {
        this.config = config;
        this.run();
    }
    run() {
        this.instance = this.createInstance(this.config.element);
        this.config.element.addEventListener('click', event => {
            event.preventDefault();
            this.instance.show();
        });
    }
    createInstance(triggerEl) {
        return new BootstrapTab(triggerEl);
    }
    getInstance() {
        return this.instance;
    }
}
export { Tab };
